module.exports = __webpack_public_path__ + "media/packs/src/assets/images/check-256a194e5e8ddae3d4513852a2f4c3f8.svg";